
import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt';



const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzZbPB5FTCktdwoIO0myP
DzWh23EpXROUxKOPN82is87Mh/zJxUZMlChYKfRC1DPU4/xDA/PSQG7jEu6Liywp
5gbpBU1PZd3AY2IPZ8sG5VWwZT51RagxaP05T/Ak2g9mi7IQuOYoJy63zuF04M51
ymGOyFdt8Gl1c4xVey5SWtqG2nblOvrxYel1+93coXfa3wcEaNH5dTWrB28Xo0YW
y+wUnCgFUF6YhL1O15S/gs2XQRwQT3SRUpjcELfvQE47rVnbAoP1JGMTqAh3h8dg
WXj8cHA+GMhmcDfUcyUqhWVA60pXs0g33NjrwgHWbIflINiYky6cpl4F7D76tS4z
XQIDAQAB
-----END PUBLIC KEY-----`




export function generateRSAKey() {
  let hex = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
  let key = "";
  for (let i = 0; i < 32; i++) {
    key += hex.charAt(Math.floor(Math.random() * 62));
  }
  return key
}

export function encryptedDataRSA(data) {
  let encrypt = new JSEncrypt();

  encrypt.setPublicKey(PUBLIC_KEY);



  // Perform our encryption based on our public key - only private key can read it!
  let encrypted = encrypt.encrypt(data);

  return encrypted
}

export function encryptedDataAES(data, key) {
  const plaintext = CryptoJS.enc.Utf8.parse(data)
  const secSpec = CryptoJS.enc.Utf8.parse(key)
  const ivSpec = CryptoJS.enc.Utf8.parse('abcdef9876543210')

  // secSpec = CryptoJS.lib.WordArray.create(secSpec.words.slice(0, 16 / 4));
  // ivSpec = CryptoJS.lib.WordArray.create(ivSpec.words.slice(0, 16 / 4));

  let encrypted = CryptoJS.AES.encrypt(plaintext, secSpec, {
    iv: ivSpec,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  // var decrypted = CryptoJS.AES.decrypt(encrypted, secSpec, {
  //   iv: ivSpec,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // });

  // console.log(decrypted.toString(CryptoJS.enc.Utf8))

  return encrypted.toString()
}







// Example usage







